import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos'
import {
  Box,
  Button,
  Checkbox,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import { confirmAlert } from 'react-confirm-alert' // Import
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { getPreciosYPermisos } from '../../../../actions/precios'
import { getStocksArticulos } from '../../../../actions/stocks'
import { cargarArrayPrecios, cargarArrayStocks } from '../../../../helpers/funciones'
import { isInt } from '../../../../helpers/numbers/functions'
import i18n from '../../../../lang/idiomas'
import Spinner from '../../../layout/Spinner'
import Precio from '../../Precio'
import {
  createOrderWebPresupuesto,
  deleteWebPresupuesto,
  saveWebPresupuesto,
} from '../libs/HandleWebPresupuestos'

const WebPresupuestosDetalle = ({ presupuesto, handleVerDetalle, loading, isNew, isSaved }) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const pedido = useSelector(state => state.pedidos.pedido)
  const precios = useSelector(state => state.precios.precio)
  const stocks = useSelector(state => state.stocks.stock)

  const [idPresupuesto, setIdPresupuesto] = useState('')

  const [dtoCoste, setDtoCoste] = useState('')
  const [tipo, setTipo] = useState('P')

  const [datosCliente, setDatosCliente] = useState('')
  const [datosEmisor, setDatosEmisor] = useState('')
  const [piePresupuesto, setPiePresupuesto] = useState('')

  const [lineas, setLineas] = useState([])

  const [saved, setSaved] = useState(false)
  const [modified, setModified] = useState(false)
  const [processing, setProcessing] = useState(false)

  useEffect(() => {
    // Seteamos como guardado si existe en el listado
    setSaved(isSaved)
    if (isNew) {
      // Si es fue acceso desde Resumen indicamos modificado (pueden no coincidir lineas)
      setModified(true)
    }
  }, [isSaved])

  useEffect(() => {
    // Si se ejecuta alguna accion contra el backend indicamos carga y deshabilitamos botones
    if (processing) {
      document.body.style.cursor = 'wait'
    } else {
      document.body.style.cursor = 'default'
    }
  }, [processing])

  useEffect(() => {
    //Cargamos datos del presupuesto seleccionado
    if (presupuesto) {
      setIdPresupuesto(presupuesto.id_pedido)
      setDatosCliente(presupuesto.datos_cliente)
      setDatosEmisor(presupuesto.datos_emisor)
      setPiePresupuesto(presupuesto.pie_presupuesto)
      const lineasPedido = []

      for (const linea of presupuesto.lineas) {
        linea.selected = true
        linea.precio = Number(linea.precio).toFixed(precios.decimales_precios || 2)
        linea.precio_iva = Number(linea.precio_iva).toFixed(precios.decimales_precios || 2)
        lineasPedido.push(linea)
      }

      setLineas(lineasPedido)
    }
  }, [presupuesto])

  useEffect(() => {
    //Calculamos precios y stocks
    let articulos_aux = []
    if (lineas?.length > 0) {
      articulos_aux = cargarArrayPrecios('webPresupuestos', lineas, precios)
      if (articulos_aux?.length > 0) {
        //Solo llamamos a getPrecios si hai al menos un elemento en el array
        dispatch(
          getPreciosYPermisos(
            articulos_aux, //articulos_cantidades
            'webPresupuestos', //origen
          ),
        )
      }

      articulos_aux = cargarArrayStocks('webPresupuestos', lineas, stocks, pedido)
      if (articulos_aux?.length > 0) {
        dispatch(
          getStocksArticulos(
            articulos_aux, //articulos_stock
            'webPresupuestos', //origen
          ),
        )
      }
    }
  }, [lineas])

  const aplicarDtoCoste = () => {
    // Aplicamos dto/Coste indicado
    setLineas(
      lineas.map(linea => {
        if (
          linea.selected &&
          precios?.[linea.articulo]?.[linea.presentacion]?.status === 'iddling'
        ) {
          linea.tipo = tipo
          linea.dto_cargo = Number(dtoCoste)
          let cargoAplicable = calcularDtoCosteAplicable()
          if (linea.tipo === 'P') {
            linea.precio =
              precios?.[linea.articulo]?.[linea.presentacion].precio_presentacion * cargoAplicable
            linea.precio_iva = linea.precio * calcularImpuestoAplicable(linea)
          } else if (linea.tipo === 'C') {
            linea.precio =
              precios?.[linea.articulo]?.[linea.presentacion].importe_neto_unidad * cargoAplicable
            linea.precio_iva = linea.precio * calcularImpuestoAplicable(linea)
          }
          // Ejercemos redondeo tras calculos
          linea.precio = Number(linea.precio).toFixed(precios.decimales_precios || 2)
          linea.precio_iva = Number(linea.precio_iva).toFixed(precios.decimales_precios || 2)
        }

        return linea
      }),
    )
    //Limpiamos estado local tras aplicar
    setDtoCoste('')
  }

  const blurPrecios = lineaSeleccionada => {
    // Redondeamos precios al salir foco de campo Precio
    setLineas(
      lineas.map(linea => {
        if (
          linea.articulo === lineaSeleccionada.articulo &&
          linea.presentacion === lineaSeleccionada.presentacion
        ) {
          linea.precio = Number(lineaSeleccionada.precio).toFixed(precios.decimales_precios || 2)
          linea.precio_iva = Number(lineaSeleccionada.precio_iva).toFixed(
            precios.decimales_precios || 2,
          )
        }
        return linea
      }),
    )
  }

  const calcularDtoCosteAplicable = () => {
    let auxDtoCoste = Number(dtoCoste)

    if (auxDtoCoste < 0) {
      return (100 + auxDtoCoste * -1) / 100
    } else {
      return (100 - auxDtoCoste) / 100
    }
  }

  const calcularImpuestoAplicable = linea => {
    return (100 + precios?.[linea.articulo]?.[linea.presentacion].impuesto_articulo) / 100
  }

  const modificarLineaPresupuesto = lineaSeleccionada => {
    setLineas(
      lineas.map(linea => {
        if (
          linea.articulo === lineaSeleccionada.articulo &&
          linea.presentacion === lineaSeleccionada.presentacion
        ) {
          linea = lineaSeleccionada
        }
        return linea
      }),
    )
  }

  const postAccion = () => {
    // Eliminamos "loader" y navegamos al menu o a inicio
    setProcessing(false)
    if (!isNew) {
      handleVerDetalle()
    } else {
      navigate('/')
    }
  }

  const postGuardado = () => {
    // Indicamos que el guardado fue correcto
    setSaved(true)
    setModified(false)
    setProcessing(false)
  }

  return loading || !presupuesto?.id_pedido ? (
    <Spinner showSpinner={loading} />
  ) : (
    <Box sx={{ padding: 2, marginLeft: '5%', marginRight: '5%' }}>
      {!isNew && (
        // No mostramos el botón si viene de Resumen
        <Button
          variant='contained'
          color='primary'
          sx={{ marginBottom: 2 }}
          onClick={e => {
            e.preventDefault()
            handleVerDetalle()
          }}>
          <ArrowBackIosIcon /> {i18n.t('webpresupuestos.wpvolver')}
        </Button>
      )}
      {/* Encabezado */}
      <Typography
        variant='h4'
        sx={{ marginBottom: 2, fontWeight: 'bold !important' }}>
        {i18n.t('webpresupuestos.wptitdt') + ': ' + idPresupuesto}
      </Typography>

      {/* Datos del emisor */}
      <Box sx={{ marginBottom: 2 }}>
        <Typography
          variant='h6'
          sx={{ backgroundColor: '#1976d2', color: 'white', padding: 1 }}>
          {i18n.t('webpresupuestos.wpdatemi')}
        </Typography>
        <TextField
          fullWidth
          multiline
          minRows={4}
          placeholder={i18n.t('webpresupuestos.wpphdtem')}
          value={datosEmisor}
          onChange={e => {
            e.preventDefault()
            setDatosEmisor(e.target.value)
            setModified(true)
          }}
        />
      </Box>

      {/* Datos del cliente */}
      <Box sx={{ marginBottom: 2 }}>
        <Typography
          variant='h6'
          sx={{ backgroundColor: '#1976d2', color: 'white', padding: 1 }}>
          {i18n.t('webpresupuestos.wpdatcli')}
        </Typography>
        <TextField
          fullWidth
          multiline
          placeholder={i18n.t('webpresupuestos.wpphdtcl')}
          minRows={4}
          value={datosCliente}
          onChange={e => {
            e.preventDefault()
            setDatosCliente(e.target.value)
            setModified(true)
          }}
        />
      </Box>

      {/* Texto pie presupuesto */}
      <Box sx={{ marginBottom: 2 }}>
        <Typography
          variant='h6'
          sx={{ backgroundColor: '#1976d2', color: 'white', padding: 1 }}>
          {i18n.t('webpresupuestos.wptxtpie')}
        </Typography>
        <TextField
          fullWidth
          multiline
          placeholder={i18n.t('webpresupuestos.wpphtxpi')}
          minRows={4}
          value={piePresupuesto}
          onChange={e => {
            e.preventDefault()
            setPiePresupuesto(e.target.value)
            setModified(true)
          }}
        />
      </Box>

      {/* Calcular precios */}
      <Box sx={{ marginBottom: 2 }}>
        <Typography
          variant='h6'
          sx={{ backgroundColor: '#1976d2', color: 'white', padding: 1 }}>
          {i18n.t('webpresupuestos.wpcalpre')}
        </Typography>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            marginTop: 1,
          }}>
          <Typography>{i18n.t('webpresupuestos.wptxayin')}</Typography>
          <Select
            defaultValue='P'
            value={tipo}
            onChange={e => {
              e.preventDefault()
              setTipo(e.target.value)
            }}
            sx={{ minWidth: 150 }}>
            <MenuItem value='P'>{i18n.t('webpresupuestos.wpsltp')}</MenuItem>
            <MenuItem value='C'>{i18n.t('webpresupuestos.wpsltc')}</MenuItem>
          </Select>
          <TextField
            type='number'
            placeholder='%'
            sx={{ maxWidth: 100 }}
            value={dtoCoste}
            onChange={e => setDtoCoste(e.target.value)}
          />
          <Button
            variant='outlined'
            color='primary'
            disabled={!lineas.some(linea => linea.selected === true) || !dtoCoste || processing}
            onClick={e => {
              e.preventDefault()
              setModified(true)
              aplicarDtoCoste()
            }}>
            {i18n.t('webpresupuestos.wpbtnsl')}
          </Button>
        </Box>
        <Box>
          <Typography>{i18n.t('webpresupuestos.wpaytp')}</Typography>
          <Typography>{i18n.t('webpresupuestos.wpaytc')}</Typography>
        </Box>
      </Box>

      {/* Tabla de productos */}
      <TableContainer
        component={Paper}
        sx={{ marginBottom: 2, boxShadow: 'unset' }}>
        <Table>
          <TableHead>
            <TableRow
              className={'titulos-detalle-webPresupuestos'}
              sx={{ backgroundColor: '#1976d2' }}>
              <TableCell></TableCell>
              {/* TODO: Crear stylo scss */}
              <TableCell
                className={'celda-titulo'}
                sx={{ color: 'white', fontWeight: 'bold' }}>
                {i18n.t('webpresupuestos.wpdtcod')}
              </TableCell>
              <TableCell
                className={'celda-titulo'}
                sx={{ color: 'white', fontWeight: 'bold' }}>
                {i18n.t('webpresupuestos.wpdtdes')}
              </TableCell>
              <TableCell
                className={'celda-titulo'}
                sx={{ color: 'white', fontWeight: 'bold' }}>
                {i18n.t('webpresupuestos.wpdtstk')}
              </TableCell>
              <TableCell
                className={'celda-titulo'}
                sx={{ color: 'white', fontWeight: 'bold' }}>
                {i18n.t('webpresupuestos.wpdtpre')}
              </TableCell>
              <TableCell
                className={'celda-titulo'}
                sx={{ color: 'white', fontWeight: 'bold' }}>
                {i18n.t('webpresupuestos.wpdtdto')}
              </TableCell>
              <TableCell
                className={'celda-titulo'}
                sx={{ color: 'white', fontWeight: 'bold' }}>
                {i18n.t('webpresupuestos.wpdtcos')}
              </TableCell>
              <TableCell
                className={'celda-titulo'}
                sx={{ color: 'white', fontWeight: 'bold' }}>
                {i18n.t('webpresupuestos.wpdtcan')}
              </TableCell>
              <TableCell
                className={'celda-titulo'}
                sx={{ color: 'white', fontWeight: 'bold' }}>
                {i18n.t('webpresupuestos.wpdtpud')}
              </TableCell>
              <TableCell
                className={'celda-titulo'}
                sx={{ color: 'white', fontWeight: 'bold' }}>
                {i18n.t('webpresupuestos.wpdtpim')}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {lineas?.length > 0 &&
              lineas.map(linea => {
                return (
                  <TableRow
                    key={linea.articulo + linea.presentacion}
                    className={'datos-detalle-webPresupuestos'}>
                    <TableCell
                      name='selected'
                      className={'celda-datos'}>
                      <Checkbox
                        checked={linea?.selected}
                        onClick={e => {
                          e.preventDefault()
                          linea.selected = !linea.selected
                          modificarLineaPresupuesto(linea)
                        }}
                      />
                    </TableCell>
                    <TableCell
                      name='codigo'
                      className={'celda-datos'}>
                      {linea.articulo}
                    </TableCell>
                    <TableCell
                      name='descripcion'
                      className={'celda-datos'}>
                      {linea.descripcion}
                    </TableCell>
                    <TableCell
                      name='stock'
                      className={'celda-datos'}>
                      {stocks?.[linea.articulo]?.[linea.presentacion]?.['']?.stock
                        ? stocks?.[linea.articulo]?.[linea.presentacion]?.['']?.stock !== 'S' &&
                          stocks?.[linea.articulo]?.[linea.presentacion]?.['']?.stock !== 'N'
                          ? stocks?.[linea.articulo]?.[linea.presentacion]?.['']?.stock +
                            linea.presentacion
                          : stocks?.[linea.articulo]?.[linea.presentacion]?.['']?.texto_stock
                        : null}
                    </TableCell>
                    <TableCell
                      name='precio'
                      className={'celda-datos'}>
                      <Precio
                        codigo_articulo={linea.articulo}
                        presentacion={linea.presentacion}
                        tipo_precio='bruto'
                        estilo_precio='unitario'
                        mostrar_iva='N'
                        mostrar_pres='N'
                        mostrar_dto='N'
                        anadir_descuento='N'
                      />
                    </TableCell>
                    <TableCell
                      name='dto'
                      className={'celda-datos'}>
                      <Precio
                        codigo_articulo={linea.articulo}
                        presentacion={linea.presentacion}
                        tipo_precio='descuento'
                        estilo_precio='unitario'
                        mostrar_iva='N'
                        mostrar_pres='N'
                        anadir_descuento='N'
                      />
                    </TableCell>
                    <TableCell
                      name='coste'
                      className={'celda-datos'}>
                      <Precio
                        codigo_articulo={linea.articulo}
                        presentacion={linea.presentacion}
                        tipo_precio='neto'
                        estilo_precio='unitario'
                        mostrar_pres='N'
                        mostrar_iva='N'
                        anadir_descuento='N'
                      />
                    </TableCell>
                    <TableCell
                      name='cantidad'
                      className={'celda-datos-input'}
                      sx={{ width: '10%' }}>
                      <TextField
                        type='number'
                        value={
                          isInt(linea.cantidad) ? Number(linea.cantidad).toFixed(0) : linea.cantidad
                        }
                        onFocus={e => {
                          e.preventDefault()
                          e.target.select()
                        }}
                        onChange={e => {
                          e.preventDefault()
                          // Modificamos cantidad
                          linea.cantidad = e.target.value
                          setModified(true)
                          modificarLineaPresupuesto(linea)
                        }}
                      />
                    </TableCell>
                    <TableCell
                      name='precio_ud'
                      className={'celda-datos-input'}
                      sx={{ width: '10%' }}>
                      <TextField
                        type='number'
                        value={linea.precio}
                        onFocus={e => {
                          e.target.select()
                        }}
                        onChange={e => {
                          e.preventDefault()
                          // Modificamos precio y precio_iva y tipo
                          linea.precio = e.target.value
                          linea.precio_iva = linea.precio * calcularImpuestoAplicable(linea)
                          linea.tipo = 'M'
                          linea.dto_cargo = null
                          setModified(true)
                          modificarLineaPresupuesto(linea)
                        }}
                        onBlur={e => {
                          e.preventDefault()
                          blurPrecios(linea)
                        }}
                      />
                    </TableCell>
                    <TableCell
                      name='con_iva'
                      className={'celda-datos-input'}
                      sx={{ width: '10%' }}>
                      <TextField
                        type='number'
                        disabled={true}
                        value={linea.precio_iva}
                      />
                    </TableCell>
                  </TableRow>
                )
              })}
          </TableBody>
          <TableFooter
            sx={{
              backgroundColor: 'transparent', // Fondo transparente
              '& .MuiTableCell-root': {
                border: 'none', // Elimina los bordes
                padding: '8px 16px', // Ajusta el padding para parecer texto
                fontSize: '1rem', // Ajusta el tamaño de fuente
              },
              '& .MuiTableRow-root': {
                border: 'none', // Asegúrate de que las filas tampoco tengan bordes
              },
            }}>
            <TableRow className={'footer-webPresupuestos-detalle'}>
              <TableCell colSpan={7} />
              <TableCell>
                <Typography
                  variant='h6'
                  className={'titulo-footer-webPresupuestos-detalle'}
                  sx={{
                    fontWeight: 'bold !important',
                  }}>
                  {'Totales: '}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography
                  variant='h6'
                  className={'titulo-footer-webPresupuestos-detalle'}
                  sx={{ fontWeight: 'bold !important' }}>
                  {lineas
                    ?.reduce(
                      (totalPedido, lin) =>
                        Number.parseFloat(totalPedido) + Number.parseFloat(lin.precio || 0),
                      0,
                    )
                    .toFixed(precios.decimales_precios || 2)}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography
                  variant='h6'
                  className={'titulo-footer-webPresupuestos-detalle'}
                  sx={{ fontWeight: 'bold !important' }}>
                  {lineas
                    ?.reduce(
                      (totalPedido, lin) =>
                        Number.parseFloat(totalPedido) + Number.parseFloat(lin.precio_iva || 0),
                      0,
                    )
                    .toFixed(precios.decimales_precios || 2)}
                </Typography>
              </TableCell>
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>

      {/* Botones */}

      <Box sx={{ display: 'flex', gap: 1 }}>
        <Button
          variant='contained'
          color='primary'
          disabled={!saved || processing}
          onClick={e => {
            e.preventDefault()
            if (modified) {
              confirmAlert({
                title: i18n.t('webpresupuestos.wpdttial'),
                message: i18n.t('webpresupuestos.wpdttxal'),
                closeOnEscape: false,
                closeOnClickOutside: false,
                buttons: [
                  {
                    label: i18n.t('general.aceptar'),
                    onClick: () => {
                      dispatch(createOrderWebPresupuesto(idPresupuesto, postAccion))
                    },
                  },
                  {
                    label: i18n.t('general.cancelar'),
                    onClick: () => {},
                  },
                ],
              })
            } else {
              setProcessing(true)
              dispatch(createOrderWebPresupuesto(idPresupuesto, postAccion))
            }
          }}>
          {i18n.t('webpresupuestos.wpdtgnpd')}
        </Button>
        <Button
          variant='contained'
          color='error'>
          {i18n.t('webpresupuestos.wpdtpdfr')}
        </Button>
        <Button
          variant='contained'
          color='error'>
          {i18n.t('webpresupuestos.wpdtpdfd')}
        </Button>
        <Button
          variant='outlined'
          color='error'
          disabled={!saved || processing}
          onClick={e => {
            e.preventDefault()
            setProcessing(true)
            dispatch(deleteWebPresupuesto(idPresupuesto, postAccion))
          }}>
          {i18n.t('webpresupuestos.wpdtbrrp')}
        </Button>
        <Button
          variant='contained'
          color='success'
          disabled={(saved && !modified) || processing}
          onClick={e => {
            e.preventDefault()
            let nuevoPresupuesto = {
              id_pedido: idPresupuesto,
              datos_emisor: datosEmisor,
              datos_cliente: datosCliente,
              pie_presupuesto: piePresupuesto,
              lineas: lineas,
            }
            setProcessing(true)
            dispatch(saveWebPresupuesto(nuevoPresupuesto, postGuardado))
          }}>
          {i18n.t('webpresupuestos.wpdtguap')}
        </Button>
      </Box>
    </Box>
  )
}

export default WebPresupuestosDetalle
